function handleTabSelection(e, dropdown) {
  e.preventDefault();

  const selectedTab = e.target;
  const selectedTabLabel = selectedTab.textContent;
  const dropdownToggle = dropdown.querySelector('.dropdown-toggle');

  dropdownToggle.textContent = selectedTabLabel;
}

export function initializeTabsDropdown() {
  const tabsDropdowns = document.querySelectorAll('.tabs');

  tabsDropdowns.forEach((tabDropdown) => {
    const tabs = tabDropdown.querySelectorAll('.dropdown-item');

    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => handleTabSelection(e, tabDropdown));
    });
  });
}
